import React from 'react';
import { motion } from 'framer-motion';

const LoadingCard: React.FC = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="glass backdrop-blur-sm rounded-2xl p-6 border border-white/20 dark:border-white/10 shadow-lg"
    >
      <div className="space-y-4">
        {/* Header skeleton */}
        <div className="flex items-center justify-between">
          <div className="shimmer h-6 w-24 rounded-lg bg-slate-200 dark:bg-slate-700"></div>
          <div className="shimmer h-4 w-4 rounded-full bg-slate-200 dark:bg-slate-700"></div>
        </div>
        
        {/* Status skeleton */}
        <div className="space-y-2">
          <div className="shimmer h-8 w-32 rounded-lg bg-slate-200 dark:bg-slate-700"></div>
          <div className="shimmer h-4 w-48 rounded bg-slate-200 dark:bg-slate-700"></div>
        </div>
        
        {/* Footer skeleton */}
        <div className="pt-2 border-t border-slate-200 dark:border-slate-700">
          <div className="shimmer h-3 w-36 rounded bg-slate-200 dark:bg-slate-700"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default LoadingCard;